package org.multiplatform.kotfolio.pages.kids.grade_3

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kids/grade_3/human_body")
@Composable
fun Grade3BodyPage() {
    BlogLayout(
        PageProperties(
            "Human Body",
            "Our body is made up of different parts, like hands, legs, eyes, ears, and more. Each of these parts has its own special job to do."
        ),
        BlogProperties("Grade 3", "Human Body")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "New Words",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Consists",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cell",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Organ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tissues (પેશીઓ)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Intestine (આંતરડું)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Urethra (મૂત્રમાર્ગ)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bladder (મૂત્રાશય)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Oxygen",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Saliva",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Word Galaxy",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "Sense Organs",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tongue",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Eyes",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Nose",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hands",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Legs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Ears",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Brain",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Brain is an important organ of our body and it is protected by the skull. It has three main parts namely:",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Fore Brain",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Mid Brain",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Hind Brain",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Brain is the commanding centre of our body and it helps us to think and perform various actions.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Every action that we do like moving our hands, sitting or walking is possible only because of our brain.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Organ System",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The organ systems inside our body carry out different functions.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Many organs together form an organ system. A particular organ system carries on a particular task. Some important organ systems are:",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Respiratory system",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Digestive system",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Circulatory system",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Nervous system",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Skeletal system",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Muscular system",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Excretory system",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Reproductive system",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "THE RESPIRATORY SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The respiratory system consists of the nose, the wind pipe and the lungs. We take in air through our nose. The hair in the nose prevent dust and germs from entering our body.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The air then goes to our lungs through the wind pipe.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The air that we breathe in has a gas called oxygen.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The lungs from the air and supply it to the various parts of our body.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This oxygen burns up the food we eat and gives us energy.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The air we breathe out is impure and has carbon dioxide in it.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Breathing purifies our blood.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should breathe in fresh air.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should keep the windows of our rooms open.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should breathe through our nose, not our mouth.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should not cover our face while sleeping.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "THE DIGESTIVE SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The digestive system consists of mouth, stomach, small intestine, large intestine and anus.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The food that we eat goes into our mouth first where it is chewed into smaller pieces with the help of the teeth.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The food that we chew, mixes with saliva and becomes soft.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The food then goes to the stomach.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the stomach, the food mixes with some digestive juices.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "About four hours after eating, the food goes into the small intestine.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In small intestine the food is further digested, taken in by the blood and carried to the other parts of the body.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The undigested food goes to the large intestine and from there it goes out of the body through the anus in the form of faeces.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "THE CIRCULATORY SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The circulatory system is made up of the heart, blood and blood vessels. The heart is the most powerful pump. It pumps blood to different parts of the body. The blood vessels carry blood to all the parts of the body by the heart and from all organs to the heart.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "THE NERVOUS SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The nervous system is made up of the brain, spinal cord and nerves. The brain is called the 'master organ of the body'. It control the functions of all other organs of the body. The brain receives messages from the sense organs through the nerves. It then sends out orders for actions. Thus, all our actions are controlled by the brain.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "THE SKELETAL SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Our body is made up of 206 bones.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "These bones are joined together to make up the Skeletal system.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The bones give shape and support to the body.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We can stand, walk and move because of our bones.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Also, our bones protect all the soft organs of our body like the heart, the brain.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "THE MUSCULAR SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The muscular system is made up of muscles. Our muscles along with the bones help the body and its parts to move. There are about 650 muscles in our body.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "THE BREATHING SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The breathing system is made up of nose, windpipe and lungs.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We breathe in air through our nose. The air then goes to the lungs via windpipe.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the lungs, the blood takes oxygen from the air. It then carries oxygen to different parts of the body. The oxygen burns the food and releases energy that we need to do different activities. The air we breathe out contains carbon dioxide. It is a harmful gas.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "THE EXCRETORY SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The excretory system is made up of the kidneys, lungs and skin.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The waste in the body has to be removed regularly for the body to work smoothly.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This is done by the organs of the excretory system.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The kidneys keep our blood clean and helps in removing urine.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The skin removes sweat.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The lungs throw out carbon dioxide.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "THE REPRODUCTIVE SYSTEM",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The organs of this system help to produce babies. Because of this system life on earth goes on.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Answer the following questions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is an organ system?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "A group of organ that work together to perform a particular function is called an organ system.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What happens when an organ system doesn't work properly?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "When an organ system fails, it can cause health complications.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Hoe many bones are there in an adult human body?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "There are 206 bones in an adult human body.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the role of stomach in digestion?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = " Stomach makes acid and powerful enzymes that break the food down and change it to a liquid or paste. From there, food moves to small intestine.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which organ of the digestive system holds the food and breaks it down into smaller pieces?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Stomach holds the food and break it down into smaller pieces.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which part of the body removes waste in the form of sweat?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Skin removes waste in the from of sweat.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What's the role of the nervous system in the human body?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The nervous system controls all of our bodily functions, allowing us to think, move, and feel. The brain, spinal cord, and nerves are all part of it.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the role of the immune system in the human body?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The immune system protects us from diseases and infections. It fights off dangerous microbes that can make us sick.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Can you name some primary organ systems in our body?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The circulatory (રુધિરાભિસરણ), digestive (પાચનસંબંધી), respiratory (શ્વસન-સંબંધી), and neurological (ચેતાતંત્ર-સંબંધિત) systems etc. are among the 11 primary organ systems in the human body.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is digestion?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The process of breaking down food into small pieces that our body can use is called digestion.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain the process of digestion with the help of a diagram.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The organ system that helps in digestion of consumed food is called the digestive system. Digestion is the process of changing food into smaller food into smaller substances so that it can easily be absorbed by the body. Mouth, food pipe, stomach, small intestine, large intestine and anus form the digestive system.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a joint? Where do you find joint in our body?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The place where two or more bones meet is called a joint in our elbow, wrist, knee, ankle and skull",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the main function of the excretory system?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The main function of the excretory system is to remove wastes from our body.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why is the brain called the master organ of the body?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The brain is called the 'master organ of the body'. It controls the functions of all other organs of the body.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the main function of the excretory system?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The main function of the excretory system is to remove wastes from our body.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are veins and arteries?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Arteries are thick walled tubes that carry the pure blood from the heart.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Veins are thin walled tubes that carry the impure blood back to the heart.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is circulation?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Our heart works like a pump. The movement of the blood through the blood vessels by the pumping action of heart is called circulation.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the function of heart?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Our heart works like a pump. The heart sends blood around in our body. The blood provides your body with the oxygen and nutrients it needs. It also carries away unwanted carbon dioxide and waste products.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain the journey of waste from the kidneys to the Urethra.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Kidneys clean the blood and remove  the waste from it.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Waste in the form of urine travels through ureter to urinary bladder.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Waste/urine is collected in urinary  bladder.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Urine exits the body through urethra.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which part of the body filters the blood?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = " Kidneys filter the blood in our body.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which two organ systems help the body and its parts to move?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The muscular system and the skeletal system together help the body the move.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How many bones and muscles are there in our body?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "There are 206 bones and 600 muscles in the human body.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }
        }
    }
}

//https://vastralpisstd3.blogspot.com/2026/09/grade-3-evs-ch-4-human-body-nb-wb.html
//https://www.scribd.com/document/710816643/EVS-Learning-material-class-3-Our-Body-A-Living-Machine
//https://www.tiwariacademy.com/ncert-solutions/class-3/science/chapter-6/
//https://vastralpisstd4.blogspot.com/2023/09/std-4-sub-evs-ch-7-human-body-system.html?view=sidebar
//https://edurev.in/t/334339/Chapter-Notes-Our-Body
//https://www.slideshare.net/slideshow/cbse-4th-science-my-body-internal-organs/249864700








